export enum FeatureFlag {
  FireboltAppReadOnlyMaintenanceMode = "fireboltAppReadOnlyMaintenanceMode",
  FireboltAppFullMaintenanceMode = "fireboltAppFullMaintenanceMode",
  FireboltAppEnableContactSupportFormLoggedIn = "fireboltAppEnableContactSupportFormLoggedIn",
  FireboltAppEnableQueryProfile = "fireboltAppEnableQueryProfile",
  ServiceIdentityBillingEnableRegisterWithCredits = "serviceIdentityBillingEnableRegisterWithCredits",
  FireboltAppEnableEngineObservAndQueryHistory = "fireboltAppEnableEngineObservAndQueryHistory",
  FireboltAppEnableEngineClusterProperty = "fireboltAppEnableEngineClusterProperty",
  FireboltAppEnableBillingV3 = "fireboltAppEnableBillingV3",
  FireboltAppEnableEditions = "fireboltAppEnableEditions",
  FireboltAppEnableIngestionWizard = "fireboltAppEnableIngestionWizard",
  FireboltAppEnableRoleWizard = "fireboltAppEnableRoleWizard",
  FireboltAppEnableLargeInstanceTypes = "fireboltAppEnableLargeInstanceTypes",
  FireboltAppEnableXsInstanceType = "fireboltAppEnableXsInstanceType",
  FireboltAppShowRolesPage = "fireboltAppShowRolesPage",
  FireboltAppEnableRegistrationPage = "fireboltAppEnableRegistrationPage",
  FireboltAppEnableReadCsvNewParams = "fireboltAppEnableReadCsvNewParams",
  FireboltAppEnableDemoTool = "fireboltAppEnableDemoTool",
  FireboltAppCollectSignupFirstStep = "fireboltAppCollectSignupFirstStep",
  AccountDbInformationSchemaViews = "accountDbInformationSchemaViews",
  FireboltAppEnablePrivateLink = "fireboltAppEnablePrivateLink",
  FireboltAppEnableBillingPaymentMethods = "fireboltAppEnableBillingPaymentMethods",
  FireboltAppEnableWireTransfer = "fireboltAppEnableWireTransfer",
  FireboltAppEnableACH = "fireboltAppEnableAch",
  FireboltAppEnableGcpPayment = "fireboltAppEnableGcpPayment",
  FireboltAppEnableCreditCardPayments = "fireboltAppEnableCreditCardPayments",
  FireboltAppEnableUiOwnership = "fireboltAppEnableUiOwnership",
  FireboltAppEnableOrbac = "fireboltAppEnableOrbac",
  FireboltAppEnableOrbacPage = "fireboltAppEnableOrbacPage",
  FireboltAppEnableProactiveWarnings = "fireboltAppEnableProactiveWarnings",
  FireboltAppEnableServiceAccounts = "fireboltAppEnableServiceAccounts",
  FireboltAppEnableChatBot = "fireboltAppEnableChatBot",
  FireboltAppEnableTransactions = "fireboltAppEnableTransactions",
  FireboltAppEnableQueryCacheRatio = "fireboltAppEnableQueryCacheRatio",
  FireboltAppEnableHistoryExplain = "fireboltAppEnableHistoryExplain",
  FireboltAppEnableTimelineExplain = "fireboltAppEnableTimelineExplain",
  FireboltAppEnableFlamegraphExplain = "fireboltAppEnableFlamegraphExplain",
  FireboltAppEnableRemainingCredits = "fireboltAppEnableRemainingCredits",
  FireboltAppCreditsValue = "fireboltAppCreditsValue",
  FireboltAppEnableDatabasesPrivilegesInEdit = "fireboltAppEnableDatabasesPrivilegesInEdit",
  FireboltAppEngineDefaultValuesOnCreate = "fireboltAppEngineDefaultValuesOnCreate",
  FireboltAppDatabasesLimitForPrivilegesLoad = "fireboltAppDatabasesLimitForPrivilegesLoad",
  FireboltAppEnableAiInEditor = "fireboltAppEnableAiInEditor",
  FireboltAppEnableGcpAccount = "fireboltAppEnableGcpAccount",
  FireboltAppEnableGcpFakeSystemEngine = "fireboltAppEnableGcpFakeSystemEngine",
  FireboltAppEnableConnectWizard = "fireboltAppEnableConnectWizard",
  FireboltAppEnableNewSidebarExperience = "fireboltAppEnableNewSidebarExperience",
  FireboltAppUseLegacySearch = "fireboltAppUseLegacySearch",
}

export const FEATURE_FLAG_INFO_MESSAGE = {
  [FeatureFlag.FireboltAppReadOnlyMaintenanceMode]:
    "Application is in read-only mode",
};
